import { Color3 } from "@babylonjs/core/Maths/math.color";
import { CreateLineSystem } from "@babylonjs/core/Meshes/Builders/linesBuilder";
import { TransformNode } from "@babylonjs/core/Meshes/transformNode";
import { Vector3 } from "@babylonjs/core/Maths/math.vector";
import { Wall } from "./mdl/Wall";
import { Util } from "./utils/Util";
export class WallCrossHair {
    static createCrossHair(pScene, pRoomManager) {
        this.mSelectedColor = pRoomManager.app.theme.mainColorBright;
        this.mNormalColor = "#DADADA";
        if (pScene == null || pRoomManager == null)
            return;
        this.mScene = pScene;
        this.mRoomManager = pRoomManager;
        if (this.mCrossHairNodeDefault == null) {
            this.mCrossHairNodeDefault = new TransformNode("wall_crossHair", this.mScene);
            this.mCrossHairNodeDefault.setEnabled(false);
        }
        if (this.mCrossHairNodeDefault == null) {
            this.mCrossHairNodeSnapped = new TransformNode("wall_crossHair", this.mScene);
            this.mCrossHairNodeSnapped.setEnabled(false);
        }
        if (this.mCrossLineX == null) {
            // default cross hair
            let tLines = new Array();
            tLines = [];
            tLines.push([new Vector3(-100, 0, 0), new Vector3(100, 0, 0)]);
            this.mCrossLineX = CreateLineSystem("", { lines: tLines, updatable: false, instance: null }, this.mScene);
            this.mCrossLineX.color = Color3.FromHexString(this.mNormalColor);
            this.mCrossLineX.isPickable = false;
            this.mCrossLineX.parent = this.mCrossHairNodeDefault;
            this.mCrossLineX.renderingGroupId = 3;
        }
        if (this.mCrossLineY == null) {
            let tLines = new Array();
            tLines = [];
            tLines.push([new Vector3(0, 0, -100), new Vector3(0, 0, 100)]);
            this.mCrossLineY = CreateLineSystem("", { lines: tLines, updatable: false, instance: null }, this.mScene);
            this.mCrossLineY.color = Color3.FromHexString(this.mNormalColor);
            this.mCrossLineY.isPickable = false;
            this.mCrossLineY.parent = this.mCrossHairNodeDefault;
            this.mCrossLineY.renderingGroupId = 3;
        }
    }
    static checkColors() {
        if (this.mRoomManager == null)
            return;
        this.mSelectedColor = this.mRoomManager.app.theme.mainColorBright;
    }
    static beginMoving(pStartPosition) {
        this.checkColors();
        if (this.mCrossHairNodeDefault !== null) {
            this.mCrossHairNodeDefault.position = Util.to3d(pStartPosition);
            this.mCrossHairNodeDefault.setEnabled(true);
        }
        if (this.mCrossHairNodeSnapped !== null)
            this.mCrossHairNodeSnapped.position = Util.to3d(pStartPosition);
    }
    static endMoving() {
        this.checkColors();
        if (this.mCrossHairNodeDefault !== null)
            this.mCrossHairNodeDefault.setEnabled(false);
        if (this.mCrossHairNodeSnapped !== null)
            this.mCrossHairNodeSnapped.setEnabled(false);
    }
    static updateCrossHair(pPos) {
        this.checkColors();
        if (this.mRoomManager == null ||
            this.mCrossLineX == null ||
            this.mCrossLineY == null)
            return;
        if (!this.mRoomManager.app.settings.snapping.boundingBoxEnabled ||
            !this.mRoomManager.app.settings.snapping.gridEnabled) {
            this.mCrossLineX.color = Color3.FromHexString(this.mNormalColor);
            this.mCrossLineY.color = Color3.FromHexString(this.mNormalColor);
        }
        if (this.mCrossHairNodeDefault !== null && this.mCrossHairNodeDefault.isEnabled())
            this.mCrossHairNodeDefault.position = Util.to3d(pPos);
        if (this.mCrossHairNodeSnapped !== null && this.mCrossHairNodeSnapped.isEnabled())
            this.mCrossHairNodeSnapped.position = Util.to3d(pPos);
    }
    static setCrossHair(psnapped) {
        this.checkColors();
        if (this.mCrossHairNodeDefault !== null)
            this.mCrossHairNodeDefault.setEnabled(true);
        if (this.mCrossLineX == null || this.mCrossLineY == null)
            return;
        switch (psnapped) {
            case Wall.WallSnapState.None:
                this.mCrossLineX.color = Color3.FromHexString(this.mNormalColor);
                this.mCrossLineY.color = Color3.FromHexString(this.mNormalColor);
                break;
            case Wall.WallSnapState.Horizontal:
                this.mCrossLineX.color = Color3.FromHexString(this.mSelectedColor);
                this.mCrossLineY.color = Color3.FromHexString(this.mNormalColor);
                break;
            case Wall.WallSnapState.Vertical:
                this.mCrossLineX.color = Color3.FromHexString(this.mNormalColor);
                this.mCrossLineY.color = Color3.FromHexString(this.mSelectedColor);
                break;
            case Wall.WallSnapState.Point:
                this.mCrossLineX.color = Color3.FromHexString(this.mSelectedColor);
                this.mCrossLineY.color = Color3.FromHexString(this.mSelectedColor);
                break;
            default:
                break;
        }
    }
}
WallCrossHair.mRoomManager = null;
WallCrossHair.mCrossHairNodeDefault = null;
WallCrossHair.mCrossHairNodeSnapped = null;
WallCrossHair.mCrossLineX = null;
WallCrossHair.mCrossLineY = null;
